import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { NgClass } from "@angular/common";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { MatListModule } from "@angular/material/list";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { EmaacAlertHistoryComponent } from "../emaac-alert-history.component";

/**
 * Side menu item that opens the EMAAC alert history. Shown to EMAAC accounts at the bottom of the
 * side menu, right above the logout options. Looks like the items in the global navigation.
 */
@Component({
  selector: "app-emaac-alert-history-nav-item",
  templateUrl: "./emaac-alert-history-nav-item.component.html",
  styleUrls: ["./emaac-alert-history-nav-item.component.css"],
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [NgClass, MatListModule, MatTooltipModule, TranslateModule],
})
export class EmaacAlertHistoryNavItemComponent {
  @Input() user: any;
  @Input() showTitles: boolean;

  constructor(private router: Router, private dialog: MatDialog) {}

  /** EMAAC accounts (role level 120), outside the landing page */
  get visible(): boolean {
    return this.user?.roleLevel === 120 && this.router.url !== "/landing-page";
  }

  /** Open the EMAAC alert history on top of the current page */
  openEmaacAlertHistory(): void {
    this.dialog.open(EmaacAlertHistoryComponent, {
      width: "90vw",
      maxWidth: "1400px",
    });
  }
}
